import React from 'react'
import GlobalSidebar from '../../../GlobalComponent/GlobalSidebar'


export default function Sidebar({ page_name = "", isFixed = true }) {

  return (
    <>
      <GlobalSidebar page_name={page_name} isFixed={isFixed} />
    </>
  )
}
